/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Address_DisplayInputs */

const en_address_display = /** @type {(inputs: Address_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Address`)
};

const id_address_display = /** @type {(inputs: Address_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan Alamat`)
};

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const es_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const fr_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const de_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const ja_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const zh_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const ar_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const it_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const ru_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const pt_address_display = en_address_display;

/** @type {(inputs: Address_DisplayInputs) => LocalizedString} */
const ko_address_display = en_address_display;

/**
* | output |
* | --- |
* | "Display Address" |
*
* @param {Address_DisplayInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const address_display = /** @type {((inputs?: Address_DisplayInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Address_DisplayInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_address_display(inputs)
	if (locale === "es") return es_address_display(inputs)
	if (locale === "fr") return fr_address_display(inputs)
	if (locale === "de") return de_address_display(inputs)
	if (locale === "ja") return ja_address_display(inputs)
	if (locale === "zh") return zh_address_display(inputs)
	if (locale === "ar") return ar_address_display(inputs)
	if (locale === "id") return id_address_display(inputs)
	if (locale === "it") return it_address_display(inputs)
	if (locale === "ru") return ru_address_display(inputs)
	if (locale === "pt") return pt_address_display(inputs)
	return ko_address_display(inputs)
});